import React from 'react';
import { TClickHandlerMouseEvent } from 'components/buttons/types';

interface IButton {
  children?: React.ReactNode;
  clickHandler?: (data: TClickHandlerMouseEvent) => void;
  appearance?:
    | 'primary'
    | 'secondary'
    | 'tertiary'
    | 'danger'
    | 'danger_secondary'
    | 'success'
    | 'success_secondary';
  disabled?: boolean;
  loading?: boolean;
  size?: 'xs' | 'sm' | 'normal' | 'lg';
  customClassName?: string;
  title?: string;
  type?: 'button' | 'submit' | 'reset';
}

const buttonApperanceFactory = (
  appearance:
    | 'primary'
    | 'secondary'
    | 'tertiary'
    | 'danger'
    | 'danger_secondary'
    | 'success'
    | 'success_secondary'
) => {
  switch (appearance) {
    case 'primary': {
      return 'btn bg-c-blue hover:bg-c-dark-blue text-white';
    }
    case 'secondary': {
      return 'btn border-c-gray hover:border-c-blue text-c-blue dark:border-c-gray dark:hover:border-white dark:text-c-medium-blue';
    }
    case 'tertiary': {
      return 'btn border-c-gray hover:border-c-blue text-gray-600 dark:border-c-gray dark:hover:border-white dark:text-white';
    }
    case 'danger': {
      return 'btn bg-c-danger hover:bg-c-danger-hover text-white';
    }
    case 'danger_secondary': {
      return 'btn bg-c-danger hover:bg-c-danger-hover text-white';
    }
    case 'success': {
      return 'btn bg-c-success hover:bg-c-success-hover text-white';
    }
    case 'success_secondary': {
      return 'btn border-c-gray hover:border-c-blue text-c-success dark:border-c-gray dark:hover:border-white';
    }
  }
};

export const Button: React.FC<IButton> = ({
  children,
  clickHandler,
  size,
  disabled,
  loading,
  appearance,
  customClassName,
  type,
  title,
}) => (
  <button
    title={title}
    type={type}
    onClick={clickHandler}
    disabled={!!(disabled || loading)}
    className={` 
            relative
            outline-none
            ${customClassName || ''}
            ${
              disabled || loading
                ? 'disabled:border-c-gray disabled:bg-gray-100 disabled:text-gray-400 disabled:cursor-not-allowed dark:disabled:border-gray-600 dark:disabled:bg-gray-800 dark:disabled:text-gray-500'
                : ''
            }
            ${size ? `btn-${size}` : ''} 
            ${appearance ? buttonApperanceFactory(appearance) : ''}
            `}
  >
    {loading ? (
      <>
        <svg
          className="animate-spin w-4 h-4 fill-current flex-shrink-0"
          viewBox="0 0 16 16"
        >
          <path d="M8 16a7.928 7.928 0 01-3.428-.77l.857-1.807A6.006 6.006 0 0014 8c0-3.309-2.691-6-6-6a6.006 6.006 0 00-5.422 8.572l-1.806.859A7.929 7.929 0 010 8c0-4.411 3.589-8 8-8s8 3.589 8 8-3.589 8-8 8z" />
        </svg>
        <span className="ml-2">Loading</span>
      </>
    ) : (
      children
    )}
  </button>
);
